//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');
  const ITERATION_MAX = 5;
  let configurationManagerInstance;

  curalate.service('RightsManagementService', [
    '$http',
    'PromiseService',
    function(
            $http,
            PromiseService,
        ) {
      this.configurationManager = configurationManagerInstance;

            //
            // REST API endpoints
            //

      this.getRightsRequestsAsync = function(params) {
        return PromiseService.processHttpResponse($http.get('/api/rights-management/requests', { params }));
      };

      this.getRightsConfigurationsAsync = function(params) {
        return PromiseService.processHttpResponse($http.get('/api/rights-management/configurations', { params }));
      };

      this.updateRightsConfigurationAsync = function(data) {
        return PromiseService.processHttpResponse($http.post('/api/rights-management/configurations', data));
      };

      this.deleteRightsConfigurationAsync = function(configurationId) {
        return PromiseService.processHttpResponse($http.delete(`/api/rights-management/configurations/${configurationId}`));
      };

      // TODO: SYND-3440: Consider migrating to framework agnostic API file. e.g. @apis/rightsManagementApi.ts
      this.getTermsAndConditions = function () {
        const gateway = CURALATE_ENV.WEB_GATEWAY_URL;

        return PromiseService.processHttpResponse(
          $http.get(`${gateway}/api/v1/rights/terms-and-conditions/url`),
        );
      };

      this.updateTermsAndConditions = function (url, isCustom) {
        const gateway = CURALATE_ENV.WEB_GATEWAY_URL;

        const data = {
          termsAndConditionsUrl: url,
          isCustom
        };

        return PromiseService.processHttpResponse(
          $http.put(`${gateway}/api/v1/rights/terms-and-conditions/url`, data),
        );
      };

      this.getHistoricalUrls = function () {
        const gateway = CURALATE_ENV.WEB_GATEWAY_URL;

        return PromiseService.processHttpResponse(
          $http.get(`${gateway}/api/v1/rights/terms-and-conditions/historical/url`),
        );
      };

            //
            // Helpers
            //

      this.getRightsExportUrl = function() {
        return '/api/rights-management/export.csv';
      };
    },
  ]);

  function RightsConfigurationManager() {
    this.messageSet = [];
    this.configuration = null;
    this.currentIndex = 0;
  }

  RightsConfigurationManager.prototype.getConfiguration = function() {
    return angular.copy(this.configuration);
  };

  RightsConfigurationManager.prototype.setConfiguration = function(newConfig) {
    this.configuration = angular.copy(newConfig);
    this.messageSet = newConfig.rightsRequestData.data;
    return this.getConfiguration();
  };

  RightsConfigurationManager.prototype.configurationEqualTo = function(otherConfig) {
    return _.isObject(this.configuration) && _.isObject(otherConfig) && this.configuration.id === otherConfig.id;
  };

  RightsConfigurationManager.prototype.getMessageSet = function() {
    return this.messageSet;
  };

  RightsConfigurationManager.prototype.getCurrentMessage = function() {
    if (this.currentIndex <= this.messageSet.length - 1) {
      return this.messageSet[this.currentIndex];
    }

    return null;
  };

  RightsConfigurationManager.prototype.getNextMessage = function() {
    let nextIndex = this.currentIndex + 1;

    if (nextIndex >= this.messageSet.length) {
      nextIndex = 0;
    }

    this.currentIndex = nextIndex;

    return this.messageSet[this.currentIndex];
  };

  RightsConfigurationManager.prototype.getRandomMessage = function() {
    let randomIndex;
    let iterations = 0;

    if (this.messageSet.length === 0) {
      return null;
    } else if (this.messageSet.length === 1) {
      return this.messageSet[0];
    }

    do {
      randomIndex = _.random(0, this.messageSet.length - 1);
      iterations++;
    } while (randomIndex === this.currentIndex && iterations < ITERATION_MAX);

    this.currentIndex = randomIndex;

    return this.messageSet[this.currentIndex];
  };

    //
    // Here be hacks.
    //
    // Due to the nature of UIA (we bootstrap an Angular app each time the modal is opened), a vanilla Angular service
    // does not give us a "true" singleton. In this case, we need an object to persist across multiple instantiations
    // of UIA, so we manually create an instance of the RightsConfigurationManager object and save the instance in this closure
    //
    // This instance is then referenced by the RightsManagementService.
    //

  configurationManagerInstance = new RightsConfigurationManager();
})();
